import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { ReactNode } from 'react'

interface PresaleCartItem {
  quantity: number
  productId: string
}

interface PresaleContextType {
  cart: PresaleCartItem[]
  handleAddToCart: (cartItem: PresaleCartItem) => void
}

export const PresaleContext = createContext<PresaleContextType>({
  cart: [],
  handleAddToCart: () => {},
})

export const PresalesContextProvider = ({ children }: { children: ReactNode }) => {
  const [cart, setCart] = useState<PresaleCartItem[]>([])

  const handleAddToCart = useCallback(
    (cartItem: PresaleCartItem) => {
      setCart([...cart, cartItem])
    },
    [cart],
  )

  const value = useMemo(
    () => ({
      cart,
      handleAddToCart,
    }),
    [cart, handleAddToCart],
  )

  return <PresaleContext.Provider value={value}>{children}</PresaleContext.Provider>
}

export const usePresaleContext = () => useContext(PresaleContext)
